import classNames from 'classnames';
import { FloatingArrow, FloatingPortal } from '@floating-ui/react';
import { usePopoverContext } from './context';
import { ReactNode } from 'react';

interface PopoverContentProps {
    disablePadding?: boolean;
}

export function PopoverContent({
    children,
    className,
    disablePadding = false,
}: { children: ReactNode; className?: string } & PopoverContentProps) {
    const { isOpen, refs, floatingStyles, getFloatingProps, arrowRef, floatingContext } =
        usePopoverContext();

    if (!isOpen) return null;

    return (
        <FloatingPortal>
            <div
                className={classNames('Popover__content', className, {
                    'Popover__content--disable-padding': disablePadding,
                })}
                ref={refs.setFloating}
                style={{ ...floatingStyles }}
                {...getFloatingProps()}
            >
                <FloatingArrow
                    ref={arrowRef}
                    context={floatingContext}
                    fill="white"
                    width={16}
                    height={8}
                    tipRadius={4}
                />
                {children}
            </div>
        </FloatingPortal>
    );
}
